import { render } from "./interview_data.vue?vue&type=template&id=f8c89c24&scoped=true"
import script from "./interview_data.vue?vue&type=script&lang=js"
export * from "./interview_data.vue?vue&type=script&lang=js"

import "./interview_data.vue?vue&type=style&index=0&id=f8c89c24&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8c89c24"]])

export default __exports__